export default {
  'art.metaTitle': 'USFans Spreadsheet Beginner Guide: How to Research & Buy Smarter',
  'art.metaDescription':
    'New to USFans? This beginner guide explains the USFans Spreadsheet, how to browse categories, read QC photos, estimate shipping and use coupons safely.',

  'art.breadcrumbHome': 'Home',
  'art.breadcrumbGuides': 'Guides',
  'art.breadcrumbCurrent': 'Beginner Guide',

  'art.title': 'USFans Spreadsheet Beginner Guide',
  'art.subtitle': 'How to research products, read QC photos and buy with confidence',
  'art.writtenBy': 'Written by the USFans Editorial Team',
  'art.reviewedBy': 'Reviewed by the USFans Editorial Team',
  'art.updated': 'Last updated',

  'art.intro':
    'Starting out with USFans can feel overwhelming. There are product links to open, QC photos to check, shipping options to understand and warehouse details to consider. This beginner guide walks you through the USFans Spreadsheet step by step, so you can research products, understand quality checks and make informed decisions before you buy.',

  'art.h1': 'What Is the USFans Spreadsheet?',
  'art.p1a':
    'The USFans Spreadsheet is an organized resource that brings product links, categories and shopping information together in one searchable place. Instead of scrolling through scattered posts or messages, you can browse by category and find relevant items more quickly.',
  'art.p1b':
    'It is a research tool, not an official store. Always open the links, review the details on the main website and do your own checks before completing any purchase.',

  'art.h2': 'How the USFans Spreadsheet Works',
  'art.p2a': 'The idea is simple: browse a category, open a product link, compare options, then decide.',
  'art.l21': 'Browse categories such as Shoes, Hoodies, T-Shirts, Jackets and more.',
  'art.l22': 'Open a product link to view full details on the main website.',
  'art.l23': 'Compare similar items before making a decision.',
  'art.l24': 'Use the guides to understand QC, shipping and coupons.',

  'art.h3': 'Understanding the Main Categories',
  'art.p3a':
    'The spreadsheet is organized into clear categories so you can find what you need faster: Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes and Other Stuff.',
  'art.p3b':
    'Start with the category that matches what you are looking for, then explore a few items before narrowing down your choice.',

  'art.h4': 'How to Read QC Photos',
  'art.p4a':
    'QC (quality control) photos are pictures of the actual item before it ships. They help you see what you are really getting.',
  'art.l41': 'Check stitching and logo placement closely.',
  'art.l42': 'Compare colors and details against the product listing.',
  'art.l43': 'Look at measurements if they are provided.',
  'art.l44': 'Ask for more photos if something is unclear.',

  'art.h5': 'Shipping Costs and What Affects Them',
  'art.p5a':
    'Shipping can change the final cost of an order. It depends on destination, parcel weight, volume, shipping line, packaging, insurance and even the season.',
  'art.p5b':
    'Prices vary, so always check current rates and estimate before checkout rather than assuming a fixed number.',

  'art.h6': 'Coupons and Discount Codes',
  'art.p6a':
    'Coupons and discount codes can help you save, but codes change often. Always check the current status, expiration and any restrictions before applying one. If no verified active code is available, treat the regular price as your baseline.',

  'art.h7': 'Is USFans Safe? What to Check',
  'art.l71': 'Verify links before opening them.',
  'art.l72': 'Check seller information carefully.',
  'art.l73': 'Protect your account and payment details.',
  'art.l74': 'Review shipping and return conditions.',
  'art.l75': 'Be cautious with suspicious or too-good-to-be-true offers.',

  'art.h8': 'Beginner Checklist',
  'art.l81': 'Decide which category you want to browse.',
  'art.l82': 'Open and review several product links.',
  'art.l83': 'Check QC photos and measurements.',
  'art.l84': 'Estimate shipping before checkout.',
  'art.l85': 'Look for any current coupon or discount.',
  'art.l86': 'Confirm seller and payment details.',
  'art.l87': 'Review return and refund policies.',
  'art.l88': 'Keep records of your order.',

  'art.faqQ1': 'Do I need an account to browse the USFans Spreadsheet?',
  'art.faqA1':
    'Browsing categories and links does not require an account. Purchasing and account-related features are handled on the main website.',
  'art.faqQ2': 'Is the USFans Spreadsheet free to use?',
  'art.faqA2':
    'The spreadsheet itself is a free informational resource. Individual products have their own prices, which you should verify on the main website.',
  'art.faqQ3': 'How often is the spreadsheet updated?',
  'art.faqA3':
    'Updates can vary. Always check the main website for the most current listings, prices and availability.',
  'art.faqQ4': 'Can I use the spreadsheet on mobile?',
  'art.faqA4': 'Yes, the categories and links are accessible from any device with a browser.',

  'art.conclusion':
    'The USFans Spreadsheet is a helpful starting point for product research. Browse the categories, open the links, check QC photos and estimate shipping, then head to the main website to complete your purchase. For more information, return to our homepage to explore guides, reviews and shipping resources.',
  'art.ctaHome': 'Back to Homepage',
  'art.ctaSpreadsheet': 'Visit Main Website',
};